import { useState, useRef } from "react";
import Config from "../../Config";



import back from "../../back.png";



function QueryDet(props)
{

    const [tab, setTab] = useState(props.row);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);




    return (
            <div className="view_content">

              <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                   <br/>
                   <br/>
                   <div className="bg_center">

                             <div className="calColor">
                                {tab.pytanie}
                             </div>
                             <div>
                                {tab.created_at}
                             </div>


                               <br/> 
                               <br/> 

                             <table className="table">
                            
                                         <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Odpowiedź</td>                                             
                                                <td className="td_right">Ilość</td>                                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {
                                               tab.odp.map(  (odp,ix)=>{

                                                var rowStyle = " row ";
                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return <tr className={rowStyle} >
                                                            <td className="td_left">{ix+1}</td>
                                                            <td className="goleft">{odp.odp}</td>                                             
                                                            <td className=" gocenter">{odp.ilosc}</td>                                                                                                  
                                                        </tr>

                                               } )
                                            }

                                        </tbody>

                             </table>



                             <br/> 

                             <div className="calColor">
                                 Uczestnicy 
                             </div>

                             <br/>

                             <table className="table">
                            
                                         <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Uczestnik</td>                                             
                                                <td className="">Godzina</td>                                                                                                  
                                                <td className="td_right">Odpowiedź</td>                                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {
                                               tab.u.map(  (u,ix)=>{

                                                var rowStyle = " row ";
                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return <tr className={rowStyle} >
                                                            <td className="td_left">{ix+1}</td>
                                                            <td className="goleft">{u.os.nazwisko + " " + u.os.imie}</td>                                             
                                                            <td className=" gocenter">{u.czas_udzielenia_odp}</td>                                                                                                  
                                                            <td className=" gocenter">{u.odpowiedz}</td>                                                                                                  
                                                        </tr>

                                               } )
                                            }

                                        </tbody>

                             </table>




                   </div>

            </div>
    )
}


export default QueryDet;